import { reactive } from "vue";

// The workbench owns a run once it has been triggered, but Strategize keeps its own copy of the
// BCOs and sits behind it in <keep-alive>, so the outcome of a run has to reach it without a
// re-fetch. Keyed by bco_id as a string, because that is how the id travels through localStorage.
export const bcoRunStatus = reactive({});

export function publishBcoRunStatus(bcoId, runningStatus) {
    if (bcoId === null || bcoId === undefined || !runningStatus) {
        return;
    }

    bcoRunStatus[String(bcoId)] = runningStatus;
}
